// extracted by mini-css-extract-plugin
export default {"tooltipContent":"CardTooltip_tooltipContent__uvdHl"};